import { observer } from 'mobx-react'
import styles from './PayingPopup.module.less'
import close from '@/assets/images/close.png'
import { Dialog } from 'antd-mobile'
import { userService } from '@/services/userService'

export interface PayingPopupProps {
  visible: boolean
  onClose?: () => void
  onPaySuccess?: () => void
  onContinuePay?: () => void
}

const PayingPopupContent = observer((props: PayingPopupProps) => {
  return (
    <div className={styles.payingPopup}>
      <div className={styles.payingPopupBg}></div>
      <div className={styles.payingPopupTitle}>订单支付中...</div>
      <div onClick={() => props.onClose?.()} className={styles.payingPopupClose}>
        <img src={close} draggable={false} />
      </div>
      <div className={styles.payingPopupContent}>
        <p>1、如果未完成付款，请点击“继续支付”</p>
        <p>2、如果已完成支付，点击“已完成支付”刷新</p>
      </div>
      <div className={styles.payingPopupFooter}>
        <div
          className={styles.continuePayBtn}
          onClick={() => {
            userService.postUserActionRecord({
              module: '移动端官网',
              function: '支付中弹窗',
              position: '订单支付中弹窗-点击继续支付',
              action: '点击',
              element: '按钮',
            })
            props.onContinuePay?.()
          }}
        >
          继续支付
        </div>
        <div
          className={styles.completedPayBtn}
          onClick={() => {
            props.onPaySuccess?.()
          }}
        >
          已完成支付
        </div>
      </div>
    </div>
  )
})

const PayingPopup = observer((props: PayingPopupProps) => {
  return (
    <Dialog
      style={
        {
          '--max-width': '100vw',
        } as React.CSSProperties
      }
      visible={props.visible}
      onClose={props.onClose}
      bodyStyle={{
        padding: 0,
        backgroundColor: 'transparent',
      }}
      content={<PayingPopupContent {...props} />}
      getContainer={() => document.body}
    ></Dialog>
  )
})

export default PayingPopup
